var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProjectDetail',{staticClass:"content-block",attrs:{"projectId":_vm.projectId},on:{"back":_vm.onBack}})}
var staticRenderFns = []

export { render, staticRenderFns }